module.exports = __webpack_public_path__ + "media/미라과학자_demo.9593e557.mp4";